import {
  uploadUserCreationFile,
  getAuthorizedClients,
  getTemplate,
  getUploads,
  saveUserCreationFile,
  downloadExcelFile,
} from "@/api/batch-user-create-tool";
import { UTCToLocale, localeToUTC } from "@/utilities/date.js";

const adminBatchUserCreateTool = {
  namespaced: true,
  state: () => ({
    AuthorizedClients: [],
    Template: null,
    LastUploads: [],
    FileUploadStatus: "",
  }),
  getters: {
    getAuthorizedClients: (state) => {
      return state.AuthorizedClients;
    },
    getTemplate: (state) => state.Template,
    getFileUploadStatus: (state) => state.FileUploadStatus,
    getLastUploads: (state) => state.LastUploads,
  },
  actions: {
    fetchAuthorizedClients({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getAuthorizedClients(payload)
          .then((AuthorizedClients) => {
            commit("SET_AUTHORIZED_CLIENTS", AuthorizedClients);
          })
          .catch(() => {
            console.log("error occured from batch user upload tool store");
          });
      });
    },
    uploadUserCreationFile({ commit }, payload) {
      commit("SET_FILE_UPLOAD_STATUS", "uploading");
      return new Promise((resolve, reject) => {
        uploadUserCreationFile(payload)
          .then((uploadDetails) => {
            commit("ADD_LAST_UPLOAD", {
              file: payload,
              uploadResult: uploadDetails,
              uploadTime: new Date().toLocaleString(),
            });
            resolve(uploadDetails);
          })
          .catch((err) => {
            console.log("error occured from batch user upload tool store");
            reject(err);
          });
      });
    },
    getTemplate({ commit }) {
      return new Promise((resolve, reject) => {
        getTemplate()
          .then((Template) => {
            commit("SET_TEMPLATE", Template);
          })
          .catch(() => {
            console.log("error occured from batch user upload tool store");
          });
      });
    },
    updateFileUploadStatus({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_FILE_UPLOAD_STATUS", payload);
      });
    },
    getUploads({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getUploads(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    saveUserCreationFile({ commit }, payload) {
      commit("SET_FILE_UPLOAD_STATUS", "saving");
      return new Promise((resolve, reject) => {
        saveUserCreationFile(payload)
          .then((saveResult) => {
            commit("SAVE_UPLOAD", saveResult);
            resolve(saveResult);
          })
          .catch(() => {
            console.log("error occured from batch user upload tool store");
          });
      });
    },

    downloadExcelFile({ commit }, params) {
      return new Promise((resolve, reject) => {
        downloadExcelFile(params)
          .then((file) => {
            resolve(file);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "downloadExcelFile store");
          });
      });
    },
  },

  mutations: {
    SET_AUTHORIZED_CLIENTS: (state, AuthorizedClients) => {
      state.AuthorizedClients =
        AuthorizedClients.length > 0 ? AuthorizedClients : [];
    },
    SET_TEMPLATE: (state, Template) => {
      state.Template = Template;
    },
    SET_FILE_UPLOAD_STATUS: (state, status) => {
      state.FileUploadStatus = status;
    },
    ADD_LAST_UPLOAD: (state, upload) => {
      state.LastUploads = [...state.LastUploads, upload];
      state.FileUploadStatus =
        !upload.uploadResult.duplicate_user_names ||
        upload.uploadResult.duplicate_user_names.length === 0
          ? "uploaded"
          : "";
    },
    SAVE_UPLOAD: (state, saveResult) => {
      state.FileUploadStatus = "saved";
      state.LastUploads.at(-1).saveResult = saveResult;
      state.LastUploads.at(-1).saveTime = new Date().toLocaleDateString();
    },
  },
};

export default adminBatchUserCreateTool;
